import { loader as gqlLoader } from 'graphql.macro';

export const cehGraphQLSchema = gqlLoader('../../generated/graphqlAST.graphql');
